import { useRef, useEffect } from 'react';

const defaultEvents = ['mousedown', 'touchstart'];
function on(obj) {
  if (obj !== null && obj !== void 0 && obj.addEventListener) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    obj.addEventListener(...args);
  }
}
function off(obj) {
  if (obj && obj.removeEventListener) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    obj.removeEventListener(...args);
  }
}

/**
 * This custom utility is identical to the original from react-use, except that it substitutes event.target with
 * event.composedPath(). This method provides an ordered array of all DOM nodes traversed
 * during event propagation, including those within Shadow DOM.
 */
const useClickAway = function (ref, onClickAway) {
  let events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultEvents;
  const savedCallback = useRef(onClickAway);
  useEffect(() => {
    savedCallback.current = onClickAway;
  }, [onClickAway]);
  useEffect(() => {
    const handler = event => {
      const {
        current: el
      } = ref;
      el && !el.contains(event.composedPath()[0]) && savedCallback.current(event);
    };
    for (const eventName of events) {
      on(document, eventName, handler);
    }
    return () => {
      for (const eventName of events) {
        off(document, eventName, handler);
      }
    };
  }, [events, ref]);
};

export { useClickAway };
//# sourceMappingURL=useClickAway.js.map
